import { createSlice } from "@reduxjs/toolkit";
import type { Asset } from "../models/Asset";
import { INITIAL_VALUES } from "../models/InitialValueTemplate";
import type { ParametersNewTemplate } from "../models/ParametersNewTemplate";
import type { TemplateAttachment } from "../components/template-resources/models/TemplateAttachment";
import type { Template } from "../models/Template";

const TemplatesReducerInitialState: {
	INITIAL_VALUE_TEMPLATE: ParametersNewTemplate;
	INITIAL_VALUE_TEMPLATE_SELECTED: ParametersNewTemplate;
	searchAssetIdToTable: number | string;
	searchAssetName: string;
	searchText: string;
	showDownDay: boolean;
	allAssets: Asset[];
	firstTime: boolean;
	templateIdToDelete: number | null;
	rowSelectedTemplate: Template;
	assetAttachments: TemplateAttachment[];
	templateAttachmentToAdd: any;
	rowSelectedInAttachment: any;
	dataAttachmentSelected: TemplateAttachment | null;
	displayViewerAttachment: boolean;
	listAttachmentSelected: any[] | null;
	uploadFileDialog: boolean;
	templateAttachmentsList: TemplateAttachment[];
} = {
	INITIAL_VALUE_TEMPLATE: INITIAL_VALUES,
	INITIAL_VALUE_TEMPLATE_SELECTED: INITIAL_VALUES,
	searchAssetIdToTable: 0,
	searchAssetName: "",
	searchText: "",
	showDownDay: true,
	allAssets: [],
	firstTime: true,
	templateIdToDelete: null,
	rowSelectedTemplate: {
		TemplateId: null,
		TypeCode: null,
		Title: "",
		AssetId: null,
		CraftId: null,
		PeriodInDays: null,
		ExpectedShifts: null,
		WarningShifts: null,
		DownHours: null,
		DownDayCode: null,
		IsNextDownDay: null,
		DowntimeClassCode: null,
		PlannedHours: null,
		Description: null,
		NumberOfWorkers: null,
		StatusCode: null,
		CreatedTimestamp: null,
		CreatedBy: null,
		PeriodShifts: null,
		AssetName: null,
		CraftName: null,
		CraftColor: null,
		CraftCode: null,
		ScheduleStart: null,
		SchedulingPolicyCode: "",
		CronExpression: "",
	},
	assetAttachments: [],
	templateAttachmentToAdd: {},
	rowSelectedInAttachment: [],
	templateAttachmentsList: [],
	dataAttachmentSelected: null,
	displayViewerAttachment: false,
	listAttachmentSelected: [],
	uploadFileDialog: false,
};

export const TemplatesReducer = createSlice({
	name: "__",
	initialState: TemplatesReducerInitialState,
	reducers: {
		setAssetId(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE.AssetId = payload;
		},
		setShiftsPerDay(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE.shiftsPerDay = payload;
		},
		setPeriodDays(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE.selectedPeriodDays = payload;
		},
		setWarningDays(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE.selectedWarningDays = payload;
		},
		setExpectedDays(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE.selectedExpectedDays = payload;
		},
		setRowSelectedTemplate(state, { payload }) {
			state.rowSelectedTemplate = payload;
		},
		setSearchAssetIdToTable(state, { payload }) {
			state.searchAssetIdToTable = payload;
		},
		setSearchAssetName(state, { payload }) {
			state.searchAssetName = payload;
		},
		setSearchText(state, { payload }) {
			state.searchText = payload;
		},
		setShowDownDay(state, { payload }) {
			state.showDownDay = payload;
		},
		setallAssets(state, { payload }) {
			state.allAssets = payload;
		},
		setSelectedTemplate(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED = payload;
		},
		setSelectedTemplateId(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.TemplateId = payload;
		},
		setSelectedAssetId(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.AssetId = payload;
		},
		setSelectedTypeCode(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.TypeCode = payload;
		},
		setSelectedTitle(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.Title = payload;
		},
		setSelectedCraftId(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.CraftId = payload;
		},
		setSelectedDownHours(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.DownHours = payload;
		},
		setSelectedIsNextDownDay(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.IsNextDownDay = payload;
		},
		setSelectedPlannedHours(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.PlannedHours = payload;
		},
		setSelectedDowntimeClassCode(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.DowntimeClassCode = payload;
		},
		setSelectedNumberOfWorkers(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.NumberOfWorkers = payload;
		},
		setSelectedDescription(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.Description = payload;
		},
		setSelectedExpectedShifts(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.ExpectedShifts = payload;
		},
		setSelectedWarningShifts(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.WarningShifts = payload;
		},
		setSelectedPeriodShifts(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.PeriodShifts = payload;
		},
		setSelectedAssetName(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.AssetName = payload;
		},
		setSelectedShiftsPerDay(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.shiftsPerDay = payload;
		},
		setSelectedPeriodDays(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.selectedPeriodDays = payload;
		},
		setSelectedWarningDays(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.selectedWarningDays = payload;
		},
		setSelectedExpectedDays(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.selectedExpectedDays = payload;
		},
		setSelectedSchedulingPolicyCode(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.SchedulingPolicyCode = payload;
		},
		setSelectedScheduleStart(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.ScheduleStart = payload;
		},
		setSelectedCronExpression(state, { payload }) {
			state.INITIAL_VALUE_TEMPLATE_SELECTED.selectedCronExpression = payload;
		},
		setTemplateIdToDelete(state, { payload }) {
			state.templateIdToDelete = payload;
		},
		setFirstTime(state, { payload }) {
			state.firstTime = payload;
		},
		setAssetAttachmentsList(state, { payload }) {
			state.assetAttachments = payload;
		},
		setTemplateAttachmentsList(state, { payload }) {
			state.templateAttachmentsList = payload;
		},
		setTemplateAttachmentToAdd(state, { payload }) {
			state.templateAttachmentToAdd = payload;
		},
		setRowSelectedInAttachment(state, { payload }) {
			state.rowSelectedInAttachment = payload;
		},
		setDataAttachmentSelected(state, { payload }) {
			state.dataAttachmentSelected = payload;
		},
		setDisplayViewerAttachment(state, { payload }) {
			state.displayViewerAttachment = payload;
		},
		setListAttachmentSelected(state, { payload }) {
			state.listAttachmentSelected = payload;
		},
		setUploadFileDialog(state, { payload }) {
			state.uploadFileDialog = payload;
		},
	},
});
